import React from 'react';
import { MessageSquareIcon, MailIcon, SmartphoneIcon, BellIcon, SendIcon, CheckCircle2Icon, ClockIcon, ActivityIcon } from 'lucide-react';
const channels = [{
  name: 'WhatsApp',
  icon: MessageSquareIcon,
  sent: 5200,
  delivery: 99.1,
  open: 85.4,
  lastDate: 'Today, 10:30 AM',
  status: 'Active',
  color: 'text-green-500',
  bg: 'bg-green-50'
}, {
  name: 'Email',
  icon: MailIcon,
  sent: 3100,
  delivery: 94.5,
  open: 42.1,
  lastDate: 'Yesterday, 14:15 PM',
  status: 'Active',
  color: 'text-blue-500',
  bg: 'bg-blue-50'
}, {
  name: 'SMS',
  icon: SmartphoneIcon,
  sent: 3800,
  delivery: 98.2,
  open: 95.0,
  lastDate: 'Today, 09:00 AM',
  status: 'Active',
  color: 'text-mavis-orange',
  bg: 'bg-orange-50'
}, {
  name: 'Push Notifications',
  icon: BellIcon,
  sent: 350,
  delivery: 89.0,
  open: 65.2,
  lastDate: 'Oct 15, 11:00 AM',
  status: 'Paused',
  color: 'text-purple-500',
  bg: 'bg-purple-50'
}];
const broadcasts = [{
  date: '2023-10-25 10:30 AM',
  channel: 'WhatsApp',
  subject: 'System Maintenance Notice',
  recipients: 1250,
  delivered: 1245,
  opened: 1100,
  status: 'Completed'
}, {
  date: '2023-10-25 09:00 AM',
  channel: 'SMS',
  subject: 'Tariff Update Reminder',
  recipients: 3800,
  delivered: 3750,
  opened: null,
  status: 'Completed'
}, {
  date: '2023-10-24 14:15 PM',
  channel: 'Email',
  subject: 'Monthly Commission Statement',
  recipients: 142,
  delivered: 138,
  opened: 112,
  status: 'Completed'
}, {
  date: '2023-10-24 10:00 AM',
  channel: 'WhatsApp',
  subject: 'New Campaign: Township Enterprise',
  recipients: 450,
  delivered: 448,
  opened: 390,
  status: 'Completed'
}, {
  date: '2023-10-23 16:30 PM',
  channel: 'SMS',
  subject: 'Urgent: Vending Gateway Delay',
  recipients: 3800,
  delivered: 3600,
  opened: null,
  status: 'Completed'
}, {
  date: '2023-10-22 09:00 AM',
  channel: 'Email',
  subject: 'Vendor Training Schedule',
  recipients: 142,
  delivered: 140,
  opened: 85,
  status: 'Completed'
}, {
  date: '2023-10-21 11:00 AM',
  channel: 'Push Notifications',
  subject: 'App Update Available',
  recipients: 350,
  delivered: 310,
  opened: 215,
  status: 'Completed'
}, {
  date: '2023-10-26 09:00 AM',
  channel: 'WhatsApp',
  subject: 'Weekend Support Hours',
  recipients: 1250,
  delivered: 0,
  opened: 0,
  status: 'Scheduled'
}];
export function CommChannels() {
  return <div className="p-8 max-w-7xl mx-auto animate-in fade-in duration-500" data-id="element-638">
      <div className="mb-8" data-id="element-639">
        <h1 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-640">
          Communication Channels
        </h1>
        <p className="text-gray-500" data-id="element-641">
          Manage communication channels for vendor updates, notifications, and
          support.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-642">
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-643">
          <div className="p-3 bg-mavis-teal/10 text-mavis-teal rounded-none" data-id="element-644">
            <ActivityIcon className="w-5 h-5" data-id="element-645" />
          </div>
          <div data-id="element-646">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-647">
              Active Channels
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-648">4</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-649">
          <div className="p-3 bg-mavis-blue/10 text-mavis-blue rounded-none" data-id="element-650">
            <SendIcon className="w-5 h-5" data-id="element-651" />
          </div>
          <div data-id="element-652">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-653">
              Messages Sent (MTD)
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-654">12,450</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-655">
          <div className="p-3 bg-mavis-green/10 text-mavis-green rounded-none" data-id="element-656">
            <CheckCircle2Icon className="w-5 h-5" data-id="element-657" />
          </div>
          <div data-id="element-658">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-659">
              Delivery Rate
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-660">97.2%</p>
          </div>
        </div>
        <div className="bg-white p-4 rounded-none border border-gray-100 shadow-sm flex items-center gap-4" data-id="element-661">
          <div className="p-3 bg-mavis-orange/10 text-mavis-orange rounded-none" data-id="element-662">
            <ClockIcon className="w-5 h-5" data-id="element-663" />
          </div>
          <div data-id="element-664">
            <p className="text-xs text-gray-500 font-medium uppercase" data-id="element-665">
              Avg Response Time
            </p>
            <p className="text-xl font-bold text-gray-900 font-mono" data-id="element-666">4.2 min</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-667">
        {channels.map((channel, i) => {
        const Icon = channel.icon;
        return <div key={i} className="bg-white rounded-none border border-gray-200 shadow-sm p-6" data-id="element-668">

              <div className="flex justify-between items-start mb-6" data-id="element-669">
                <div className="flex items-center gap-4" data-id="element-670">
                  <div className={`p-4 ${channel.bg} ${channel.color} rounded-none`} data-id="element-671">

                    <Icon className="w-8 h-8" data-id="element-672" />
                  </div>
                  <div data-id="element-673">
                    <h3 className="text-xl font-bold text-gray-900" data-id="element-674">
                      {channel.name}
                    </h3>
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium mt-1 ${channel.status === 'Active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-675">

                      {channel.status}
                    </span>
                  </div>
                </div>
                <div className={`w-12 h-6 rounded-full p-1 cursor-pointer transition-colors ${channel.status === 'Active' ? 'bg-mavis-teal' : 'bg-gray-200'}`} data-id="element-676">

                  <div className={`w-4 h-4 rounded-full bg-white transition-transform ${channel.status === 'Active' ? 'translate-x-6' : 'translate-x-0'}`} data-id="element-677" />

                </div>
              </div>

              <div className="grid grid-cols-3 gap-4 mb-6 pt-6 border-t border-gray-100" data-id="element-678">
                <div data-id="element-679">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-680">
                    Sent
                  </p>
                  <p className="font-mono font-bold text-gray-900 text-lg" data-id="element-681">
                    {channel.sent.toLocaleString()}
                  </p>
                </div>
                <div data-id="element-682">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-683">
                    Delivery
                  </p>
                  <p className="font-mono font-bold text-mavis-green text-lg" data-id="element-684">
                    {channel.delivery}%
                  </p>
                </div>
                <div data-id="element-685">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1" data-id="element-686">
                    Open Rate
                  </p>
                  <p className="font-mono font-bold text-mavis-blue text-lg" data-id="element-687">
                    {channel.open}%
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between text-sm text-gray-500 bg-gray-50 p-3 rounded-none border border-gray-100" data-id="element-688">
                <span className="flex items-center gap-2" data-id="element-689">
                  <ClockIcon className="w-4 h-4" data-id="element-690" /> Last Broadcast
                </span>
                <span className="font-medium text-gray-900" data-id="element-691">
                  {channel.lastDate}
                </span>
              </div>
            </div>;
      })}
      </div>

      <div className="bg-white rounded-none shadow-sm border border-gray-200 overflow-hidden" data-id="element-692">
        <div className="p-5 border-b border-gray-200 bg-gray-50 flex justify-between items-center" data-id="element-693">
          <h2 className="text-lg font-bold text-gray-900" data-id="element-694">Recent Broadcasts</h2>
          <button className="px-4 py-2 bg-mavis-teal text-white text-sm font-medium rounded-none hover:bg-mavis-teal/90 transition-colors" data-id="element-695">
            New Broadcast
          </button>
        </div>
        <div className="overflow-x-auto" data-id="element-696">
          <table className="w-full text-left border-collapse" data-id="element-697">
            <thead data-id="element-698">
              <tr className="bg-gray-50 text-gray-500 text-xs uppercase tracking-wider border-b border-gray-200" data-id="element-699">
                <th className="p-4 font-medium" data-id="element-700">Date</th>
                <th className="p-4 font-medium" data-id="element-701">Channel</th>
                <th className="p-4 font-medium" data-id="element-702">Subject</th>
                <th className="p-4 font-medium text-right" data-id="element-703">Recipients</th>
                <th className="p-4 font-medium text-right" data-id="element-704">Delivered</th>
                <th className="p-4 font-medium text-right" data-id="element-705">Opened</th>
                <th className="p-4 font-medium" data-id="element-706">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-707">
              {broadcasts.map((b, i) => <tr key={i} className="hover:bg-gray-50 transition-colors" data-id="element-708">
                  <td className="p-4 text-sm text-gray-500 whitespace-nowrap" data-id="element-709">
                    {b.date}
                  </td>
                  <td className="p-4 text-sm font-medium text-gray-900" data-id="element-710">
                    {b.channel}
                  </td>
                  <td className="p-4 text-sm text-gray-900" data-id="element-711">{b.subject}</td>
                  <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-712">
                    {b.recipients.toLocaleString()}
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-713">
                    {b.delivered.toLocaleString()}
                  </td>
                  <td className="p-4 text-sm font-mono text-gray-600 text-right" data-id="element-714">
                    {b.opened ? b.opened.toLocaleString() : '-'}
                  </td>
                  <td className="p-4" data-id="element-715">
                    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-none text-xs font-medium ${b.status === 'Completed' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`} data-id="element-716">

                      {b.status}
                    </span>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}